var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgDownCaretAlternate = function SvgDownCaretAlternate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.822 6.941a1 1 0 01-1.644 0L.891 2.197A1 1 0 011.713.628h6.574a1 1 0 01.822 1.57L5.822 6.94z",
    fill: "#5F6771"
  })));
};
export default SvgDownCaretAlternate;